import { ChangeDetectorRef, Directive, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { ReferenceDataLabels } from '../lib/constants/reference-data-labels';
import { ValidationErrors } from '../lib/models/validation/validation-errors';

@Directive()
export class BaseControlComponent implements ControlValueAccessor {
  public referenceDataLabels = ReferenceDataLabels;
  public hasErrors: boolean;

  @Output() public readonly blurEventChange = new EventEmitter<any>();
  @Input() public controlId: any;
  @Input() public labelName: string;
  @Input() public showTooltip = true;
  @Input() public tooltipName: string;
  @Input() public isFieldDisabled: boolean;
  @Input() public validationPropertyNames: Array<string>;
  @Input() public validationErrors: ValidationErrors;
  @Input() public required: boolean;
  @Input() public placeholder = '';

  @Output() public readonly valueChange = new EventEmitter<any>();
  /**
   * Values
   * label-left
   * label-top
   * label-weight-bold
   * label-weight-normal
   * label-font-size-x - where x is font size of label
   */
  @Input() public cssClasses = 'label-left label-weight-bold label-font-size-13';

  protected innerValue: any;

  protected onChangeCallback = (_: any): void => {};
  public onTouched: any = () => {};

  public constructor(protected cdRef: ChangeDetectorRef) {}

  public get value(): any {
    return this.innerValue;
  }

  public set value(newValue: any) {
    if (newValue !== this.innerValue) {
      this.innerValue = newValue;
      this.onChangeCallback(newValue);
    }
  }

  public writeValue(value: any): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  public onBlur(): void {
    this.onTouched();
    this.blurEventChange.emit();
  }

  public onValueChange(data: any): void {
    this.valueChange.emit(data);
  }

  public onErrorChange(errorState: boolean): void {
    this.hasErrors = errorState;
    this.cdRef.detectChanges();
  }

  public registerOnChange(fn: (v: any) => void): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
